import NavigationSidebar from "components/Navigation/NavigationSidebar"
import ProductCard from "components/Product/ProductColDetail"

import Slider from "components/Slider/Slider"
import { Col, Row } from "elemental"
import PropTypes from "prop-types"
import React, { Fragment } from "react"
import Responsive from "react-responsive"
import { Link } from "react-router"
import { Breadcrumb, Container, Grid } from "semantic-ui-react"
import LinkCms from "./components/Link/LinkCms"
import ProductList from "./components/Product/ProductList"
import ProductSearch from "./components/Product/ProductSearch"
import shop from "shop/shop"

// const Button = ({children, ...rest}) => <Link {...rest}>{children}</Link>
// TODO: Hotfix: bc Button as Link uses createRef which is not supported by current React version.
// Can't upgrade react because elemental will crash -> maybe use forked elemental UI
const Button = ( { children, ...rest } ) => null

const ConditionalContainer = ( { children, container, className = "" } ) => {
  if ( container ) return <Container className={className}>{children}</Container>
  return <div className={className}>{children}</div>
}

const WordPress = ( { page, slug } ) => {

  if(!page){
    return <div>Keine Seite gefunden</div>
  }

  if ( page.layout && !page.acf ) {
    page.acf = { layout: page.layout }
  }

  if ( !page || !page.content && !page.acf ) return null
  if ( page && !page.acf.layout && page.content && page.content.rendered ) return <TextPost
    html={page.content.rendered}/>
  if ( !page || !page.acf.layout || page.acf.layout.length < 1 ) return null
  let images = []

  let sidebarPlaced = false
  let sidebarCapacity = false
  let beforeSidebar = []
  let onSidebar = []
  let afterSidebar = []


  page.acf.layout.forEach( ( row, layoutKey ) => {
    layoutKey = `${slug}-${layoutKey}-${window.app._currentLanguage}`
    let wrapInRow = false
    let output = false
    const useSidebar = sidebarCapacity >= 1
    let title = false

    switch ( row.acf_fc_layout ) {
      case "sidebar":
        console.log( "place sidebar", row )
        sidebarPlaced = true
        sidebarCapacity = 1 + Number( row.size ) || 1
        break;
      case "slider":
        output = <ConditionalContainer className={`Slider relative ${row.className}`}
                                       container={row.useContainer && !useSidebar}>
          <Slider
            centerMode
            centerSlidePercentage={100}
            infiniteLoop={true}
            showThumbs={false}
            showArrows={false}
            showIndicators={false}
            showStatus={false}>
            {row.content.map( slide => {

              if(slide.cta){
                return <Link target={slide.cta.target} to={slide.cta.url} key={slide.img}
                            className="Slide">
                  <div className="slider-content ui container">
                    <div className="html" dangerouslySetInnerHTML={{ __html: slide.content }}/>

                  </div>

                  <img src={slide.img} className="ui image"/>
                </Link>
              }

              return <div key={slide.img}
                          className="Slide">
                <div className="slider-content ui container">
                  <div className="html" dangerouslySetInnerHTML={{ __html: slide.content }}/>
                  {slide.cta &&
                  <Link className={"ui button primary"}  to={slide.cta.url}
                        target={slide.cta.target}>{slide.cta.title}</Link>}
                </div>

                <img src={slide.img} className="ui image"/>
              </div>

            })}
          </Slider>
        </ConditionalContainer>
        break;

      case "images":
        wrapInRow = false
        var sizeImg = "1"
        if ( row.img.length > 1 ) {
          sizeImg += "/" + row.img.length
        }
        output =
          <ConditionalContainer className={row.className} container={row.useContainer && !useSidebar}>
            <Row>
              {(row.img && row.img.length > 0) && row.img.map( ( { img, url, cta }, key ) => {
                const useButton = img.features && img.features.includes( "useButton" )
                return (
                  <Col key={key}
                       sm={sizeImg}
                       className="cms-content cms--images relative ">
                    {cta && <div className="">
                      <Link inverted primary size="large" className="ui button img-button absolute left-2 bottom-2 margin-0"
                              as={Link}
                              to={cta.url}
                              target={cta.target}>{cta.title}</Link>
                    </div>}
                    <LinkCms to={url}>
                      <img src={img.url}
                           className="img-responsive "
                           alt=""/>
                    </LinkCms>
                  </Col>
                )
              } )}
            </Row>
          </ConditionalContainer>
        break
      case "products":
        var size = "1/" + row.ids.length
        output = <ConditionalContainer className={row.className} container={row.useContainer && !useSidebar}>
          <ProductList key={layoutKey}
                       title={row.title}
                       sm={"1/2"}
                       list={row.ids.map( o => o.id )}
                       repeat={ProductCard}> </ProductList>
        </ConditionalContainer>

        break
      case "search":
        row.cats = row.cats || []
        var cats = row.cats.map( cat => cat.id )
        output = <ConditionalContainer className={row.className} container={row.useContainer && !useSidebar}>
          <Col key={`k${row.query}+${row.cats[ 0 ]}`}>
            <ProductSearch title={row.title}
                           cats={cats[ 0 ]}
                           query={row.query}
                           repeat={ProductCard}/>
          </Col>
        </ConditionalContainer>
        break
      case "html":
        var sizeHtml = "1"
        if ( row.html.length > 1 ) {
          sizeHtml += "/" + row.html.length
        }
        wrapInRow = false
        title = row.title
        if ( !row.html.length ) return null
        output =
          <ConditionalContainer className={row.className} container={row.useContainer && !useSidebar}>
            <Row>
              {row.html.map( ( { html }, key ) => {
                return (
                  <Col key={key}
                       sm="1"
                       className="pb3"
                       md={sizeHtml}>
                    <div key={key}
                         className={`${row.css} cms-content cms--html`}
                         dangerouslySetInnerHTML={{ __html: html }}>
                    </div>
                  </Col>
                )
              } )}
            </Row>
          </ConditionalContainer>
        break
    }

    let rowTitle = null
    if ( title ) {
      rowTitle = (
        <div className="row-title">{title}</div>
      )
    }

    const section = <section key={layoutKey}
                             className="cms-content">
      {rowTitle}
      {output}
    </section>

    if ( sidebarCapacity === false ) beforeSidebar.push( section )
    if ( sidebarCapacity === 0 ) afterSidebar.push( section )
    if ( sidebarCapacity > 0 ) {
      onSidebar.push( section )
      sidebarCapacity--
    }
  } )


  return <div className="cms-entry">
    {page.acf.style && <style dangerouslySetInnerHTML={{ __html: page.acf.style }}/>}
    {beforeSidebar}
    {sidebarPlaced &&
    <Container>
      <Grid divided="vertically">
        <Responsive minWidth={790}>
          <Grid.Row>

            <Grid.Column width={3}>
              {/*BREADCRUMBS*/}
              <div className="db pv3">
                <Breadcrumb>
                  <Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
                </Breadcrumb>
              </div>
              <div className="">
                <NavigationSidebar/>
              </div>
            </Grid.Column>

            <Grid.Column width={13}>
              {/*<CategoriesGrid/>*/}
              {onSidebar}
            </Grid.Column>

          </Grid.Row>

        </Responsive>

        <Responsive maxWidth={790}>
          <Grid.Row>
            <Grid.Column width={16}>
              {onSidebar}
            </Grid.Column>
          </Grid.Row>
        </Responsive>
      </Grid>
    </Container>
    }
    <div className="after-sidebar">
      {afterSidebar}
    </div>
  </div>
}

const TextPost = ( { html } ) => {
  return <Container text>
    <div className="post"
         dangerouslySetInnerHTML={{ __html: html }}/>
  </Container>
}

WordPress.propTypes = {
  page: PropTypes.object
}

export default WordPress




// WEBPACK FOOTER //
// ./src/WordPress.js